import { create } from 'zustand';

const useValidationStore = create((set) => ({
  emailSent: false,
  setEmailSent: (value) => set({ emailSent: value }),
}));

export default useValidationStore;
